import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledDischargeSummaryFormSection = styled(StyledFlex)`
   width: 656px;
`;
